<!-- 销售员年度业绩统计-海口-->
<template>
    <div class="business-content-main">
        <div class="bread-nav">
            <breadcrumb :canBackHistory="true"></breadcrumb>
        </div>
        <div class="tab-item-ctn search-picker">
            <div class="search-ctn">
                <div class="search-ctn-left">
                    <!-- <div class="search-name">仓库</div>
                    <el-select v-model="searchData.WarehouseId" :loading="loading" class="search-item" size="small" filterable clearable remote @visible-change="getWarehouse()">
                        <el-option v-for="optionItem in WarehouseList" :label="optionItem.WarehouseName" :value="optionItem.WarehouseId" v-bind:key="optionItem.index">
                            <span style="float: left">{{ optionItem.WarehouseName }}</span>
                            <span v-if="optionItem.Type == 1" style="float: right; color: #8492a6; font-size: 13px">（前置仓）</span>
                        </el-option>
                    </el-select> -->
                    <div class="search-name">开单部门</div>
                    <el-select
                        size="small"
                        class="search-item"
                        v-model="searchData.OrgIds"
                        filterable
                        clearable
                        collapse-tags
                        reserve-keyword
                        multiple
                        @visible-change="orgVisibleChange($event)"
                        placeholder="请选择"
                    >
                        <el-option
                            v-for="optionItem in orgSearchData"
                            :key="optionItem.Id"
                            :data-msg="optionItem"
                            :label="optionItem.Name"
                            :value="optionItem.Id"
                        ></el-option>
                    </el-select>
                    <div class="search-name">业务员</div>
                    <el-select
                        v-model="searchData.SIds"
                        multiple
                        collapse-tags
                        size="small"
                        class="search-item"
                        filterable
                        placeholder="请选择"
                        @visible-change="siVisibleChange($event)"
                    >
                        <el-option v-for="(item, index) in SIdList" :key="index" :label="item.EmployeeName" :value="item.EmployeeId"></el-option>
                    </el-select>
                    <!--单据时间必选，默认当月-->
                    <div class="search-name">提交时间</div>
                    <el-date-picker
                        v-model="dateTimes"
                        type="monthrange"
                        align="right"
                        unlink-panels
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :picker-options="pickerOptions"
                        @change="handleChange"
                        size="small"
                        class="search-name"
                        style="width:335px"
                    ></el-date-picker>
                    <div class="search-name">
                        <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="getTableData">查询</el-button>
                        <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
                        <el-button size="small" class="search-btn btn-primary" v-if="permission.export" @click="exportData">
                            <i class="fa fa-file-excel-o"></i>
                            {{ permission.export }}</el-button
                        >
                        <el-button size="small" type="warning" v-if="permission.reBuildStat" class="search-btn" @click="reBuildStat">{{
                            permission.reBuildStat
                        }}</el-button>
                    </div>
                </div>
                <div class="search-ctn-right" v-if="summaryStr">
                    <div class="section-summary">
                        <div>
                            <span>{{ summaryStr ? '当前利润率：' + summaryStr : '' }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="table-ctn">
                <ux-grid
                    ref="multipleTable"
                    :data="tableSaleData"
                    border
                    style="width: 100%"
                    show-summary
                    :summary-method="getSummaries"
                    :sort-config="{ defaultSort: { field: 'RealSaleTotalAmount', order: 'desc' } }"
                >
                    <ux-table-column resizable fixed="left" width="50px" type="index" sortable title="排名"></ux-table-column>
                    <ux-table-column resizable fixed="left" min-width="100px" field="SName" title="业务员"></ux-table-column>
                    <ux-table-column resizable :title="item.OrgName" min-width="100px" v-for="(item, index) in header" :key="index">
                        <template slot-scope="scope">
                            <span v-for="(item2, index2) in scope.row.OrgtList" v-if="index == index2" :key="index2">
                                {{ item2.SaleTotal }}
                            </span>
                        </template>
                    </ux-table-column>
                    <ux-table-column resizable sortable min-width="110" fixed="right" field="SaleOrderTotalCount" title="销售单数"></ux-table-column>
                    <ux-table-column resizable sortable min-width="110" fixed="right" field="GoodsTotalCount" title="商品总数"></ux-table-column>
                    <ux-table-column resizable sortable min-width="120" fixed="right" field="SaleReturnTotalAmount" title="退货总额"></ux-table-column>
                    <ux-table-column resizable sortable min-width="120" fixed="right" field="SaleReturnTotalCount" title="退货数"></ux-table-column>
                    <ux-table-column resizable sortable min-width="120" fixed="right" field="RealSaleTotalAmount" title="实际销售额"></ux-table-column>
                    <ux-table-column resizable sortable min-width="130" fixed="right" field="SaleTotalCost" title="总成本"></ux-table-column>
                    <ux-table-column resizable sortable min-width="130" fixed="right" field="SaleTotalProfit" title="总利润"></ux-table-column>
                </ux-grid>
            </div>
        </div>
        <el-dialog :close-on-click-modal="false" title="重新生成统计数据" :visible.sync="dialogBuildStat" width="400px" append-to-body>
            <div class="dialog-content" v-if="dialogBuildStat">
                <el-form ref="form" label-position="left" label-width="70px">
                    <el-form-item label="统计日期">
                        <el-date-picker
                            value-format="yyyy-MM"
                            :picker-options="pickerOptions_build"
                            class="search-name"
                            size="small"
                            v-model="StatDate"
                            type="month"
                            placeholder=""
                        ></el-date-picker>
                    </el-form-item>
                </el-form>
                <div class="dialog-footer">
                    <el-button class="btn-primary" size="small" @click="updatSalesStat" :disabled="saveBuild">确定</el-button>
                    <el-button
                        size="small"
                        :disabled="saveBuild"
                        @click="
                            () => {
                                dialogBuildStat = false;
                            }
                        "
                        >取消</el-button
                    >
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import breadcrumb from '@/components/common/breadcrumb';
import mixin from '@/mixins/mixin';
export default {
    mixins: [mixin],
    name: '',
    components: {
        breadcrumb
    },
    data() {
        return {
            summaryStr: '',
            permission: {},
            dateTimes: [],
            orgSearchData: [],
            searchData: {
                EntpId: this.$util.getLocalStorage('userMsg').EntpId,
                OrgIds: [],
                SIds: [],
                StartDate: '',
                EndDate: '',
                WarehouseId: ''
            },
            SIdList: [],
            tableSaleData: [],
            WarehouseList: [],
            loading: false,
            tableSaleDataLength: 0,
            header: [],
            selectDate: '',
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            start.setHours(0, 0, 0), end.setHours(23, 59, 59), picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            start.setHours(0, 0, 0), end.setHours(23, 59, 59), picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            start.setHours(0, 0, 0), end.setHours(23, 59, 59), picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            start.setHours(0, 0, 0), end.setHours(23, 59, 59), picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            },
            pickerOptions_build: {
                //大于当前月分的日期不可选
                disabledDate: time => {
                    var date = new Date();
                    var year = date.getFullYear();
                    var month = date.getMonth() + 1;
                    if (month >= 1 && month <= 9) {
                        month = '0' + month;
                    }
                    var currentdate = year.toString() + month.toString();

                    var timeyear = time.getFullYear();
                    var timemonth = time.getMonth() + 1;
                    if (timemonth >= 1 && timemonth <= 9) {
                        timemonth = '0' + timemonth;
                    }
                    var timedate = timeyear.toString() + timemonth.toString();
                    return currentdate < timedate;
                }
            },
            dialogBuildStat: false,
            StatDate: '',
            saveBuild: false
        };
    },
    mounted() {
        let that = this;
        that.permission = this.$util.getPermission('SalesStat_h');

        let d = new Date();
        let year1, month1, day1;
        [year1, month1, day1] = [d.getFullYear(), d.getMonth(), d.getDate()];
        let date1 = new Date(year1, month1, day1, 23, 59, 59);
        that.dateTimes.push(date1);

        //前一天设定的日期时间
        let year2, month2, day2;
        d.setTime(d.getTime());
        [year2, month2, day2] = [d.getFullYear(), 0, d.getDate()];
        let date2 = new Date(year2, month2, 1, 0);
        that.dateTimes.unshift(date2);

        that.searchData.StartDate = date2;
        that.searchData.EndDate = date1;

        this.$util.setEnterEvent(this, this.$route.fullPath);
        this.getTableData();
    },
    methods: {
        labelHead(h, { column, index }) {
            //动态表头渲染
            let l = column.label.length;
            let f = 12; //每个字大小,其实是每个字的比例值,大概会比字体大小打差不多大
            column.minWidth = f * l; //字大小乘个数即长度 ,注意不要加px像素，这里minWidth只是一个比例值，不是真正的长度
            //然后将列标题放在一个div块中，注意块的宽度一定要100%，否则表格显示不完全
            return h('span', { class: 'table-head', style: { width: '100%' } }, [column.label]);
        },
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            if (columns.length <= 8) return [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '合计';
                } else if (index == 1) {
                    sums[index] = '';
                } else if (index < this.header.length + 2) {
                    let s = 0;
                    data.forEach((e, i) => {
                        if (e.OrgtList && e.OrgtList.length > 0)
                            e.OrgtList.forEach(ee => {
                                if (ee.OrgName == column.title) {
                                    s += ee.SaleTotal;
                                }
                            });
                    });
                    sums[index] = s.toFixed(2);
                } else {
                    const values = data.map(item => Number(item[column.property]));
                    if (!values.every(value => isNaN(value))) {
                        sums[index] = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        }, 0);
                        if (!(column.title == '销售单数' || column.title == '商品总数')) sums[index] = sums[index].toFixed(2);
                    } else {
                        sums[index] = '';
                    }
                }
            });

            return [sums];
        },
        // 重置表单
        resetSearch() {
            let that = this;
            that.searchData.EntpId = this.searchData.EntpId;
            that.searchData.SIds = [];
            that.searchData.OrgIds = [];
            that.selectDate = '';
            that.dateTimes = [];

            let d = new Date();
            let year1, month1, day1;
            [year1, month1, day1] = [d.getFullYear(), d.getMonth(), d.getDate()];
            let date1 = new Date(year1, month1, day1, 0);
            that.dateTimes.push(date1);

            //前一天设定的日期时间
            let year2, month2, day2;
            d.setTime(d.getTime());
            [year2, month2, day2] = [d.getFullYear(), d.getMonth(), d.getDate()];
            let date2 = new Date(year2, month2, 1, 0);
            that.dateTimes.unshift(date2);

            that.searchData.StartDate = date2;
            that.searchData.EndDate = date1;
        },
        // 获取数据
        getTableData() {
            if (this.searchData.StartDate == '' || this.searchData.EndDate == '') {
                this.$util.warningMsg('请选择创建时间');
                return;
            }
            this.$util
                .axiosPost({
                    url: '/api/DataStatistics/SalePerfYearStatH',
                    data: this.searchData
                })
                .then(res => {
                    let data = res.data;
                    if (data) {
                        this.tableSaleData = data.List;
                        this.tableSaleDataLength = res.count;
                        this.header = data.header;
                        this.summaryStr = data.ProfitRate + ' %';
                    } else if (res.errcode != 201 && !data) {
                        this.tableSaleData = [];
                        this.tableSaleDataLength = 0;
                        this.header = [];
                        this.summaryStr = 0 + ' %';
                    }
                    //刷新列配置,因为部门列是动态变化的，如果不刷新会影响到getSummaries的计算
                    this.$refs.multipleTable.refreshColumn();
                })
                .catch(() => {});
        },

        //当业务员下拉框出现时触发
        siVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.SIdList.length <= 1) {
                    that.$util.getSalemanListByAuth().then(data => {
                        that.SIdList = data;
                    });
                }
            }
        },
        handleChange(val) {
            if (val) {
                this.searchData.StartDate = val[0];
                this.searchData.EndDate = val[1];
            } else {
                this.searchData.StartDate = '';
                this.searchData.EndDate = '';
            }
        },
        orgVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.orgSearchData.length == 0)
                    that.$util.getParentOrgs().then(data => {
                        that.orgSearchData = data;
                    });
            }
        },
        // getWarehouse() {
        //     if (this.WarehouseList.length <= 1) {
        //         this.$util.getWarehouse(1).then(data => {
        //             this.WarehouseList = data;
        //         });
        //     }
        // },
        exportData() {
            let that = this;
            if (that.tableSaleData.length == 0) {
                that.$util.warningMsg('请选择要导出的数据');
                return;
            }
            that.$util.exportFile_post({
                url: '/api/DataStatistics/ExportSPYearStatH',
                data: that.searchData
            });
        },
        reBuildStat() {
            let d = new Date();
            let year1, month1, day1;
            [year1, month1, day1] = [d.getFullYear(), d.getMonth(), d.getDate()];
            this.StatDate = year1 + '-' + (d.getMonth() + 1);
            this.dialogBuildStat = true;
        },
        updatSalesStat() {
            let that = this;
            if (that.StatDate == '') {
                that.$util.warningMsg('请选择统计日期');
                return;
            }
            that.saveBuild = true;
            that.$util
                .axiosGet({
                    url: '/api/DataStatistics/UpdatSalesStat',
                    data: {
                        StatDate: that.StatDate
                    }
                })
                .then(res => {
                    if (res.errcode == 0) {
                        that.$util.successMsg('生成成功');
                        that.dialogBuildStat = false;
                    }
                    that.saveBuild = false;
                })
                .catch(err => {
                    that.saveBuild = false;
                });
        }
    }
};
</script>
<style lang="less">
.table-ctn {
    .elx-table--body-wrapper {
        .elx-body--row {
            td {
                height: 36px;
            }
        }
    }
}
.dialog-footer {
    text-align: right;
}
</style>
